module.exports = __webpack_public_path__ + "img/chest-0.b58602e7.png";